import React, { useEffect } from 'react';
import './residencias.css';
import { residencias } from '../../json/residencias';

const Residencias = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className='container transparencia-container'>
        <div className='row'>
        <div className='col_12'>
            <div className='transparencia_title'>
                <h1>Residencias regionales</h1>
            </div>
        </div>
                {
                residencias.map((item, index)=>(
                    <div key={ index } className='col-md-4 col-sm-6 col-12'>
                        <div className='residencia'>
                            <div className='nombreResidencia'>
                                Residencia { item.residencia }
                            </div>
                            <div>
                                <p className='datos'>Dirección:</p>
                                <p>{ item.direccion }</p>
                                <p className='datos'>Teléfono:</p>
                                <p>{ item.telefono }</p>
                                <p className='datos'>Correo electrónico:</p>
                                <p>{ item.correo }</p>
                            </div>                        
                        </div>
                    </div>
                    ))
                }
        </div>
    </div>
  )
}

export default Residencias